import React from 'react';
import PropTypes from 'prop-types';

const ProductCard = ({model, productId, banner, onClickActionBtn}) => {
  const selected = model.type === 'BANNER' && productId === banner;
  const selectedClass = selected ? ' selected' : '';
  const fontSize = model?.letter?.length > 1 ? 60 : 95;

  function renderImage(model) {
    return <img src={model.thumbImageSrc} alt="preview" />;
  }

  function renderLetter(model) {
    return <p style={{fontFamily: model.fontFamily, color: model.colorHex, fontSize}}>{model.letter}</p>;
  }

  function renderComponent(model) {
    return (
      <p
        style={{
          fontSize: fontSize * (model?.widthScale ?? 1),
          color: model.colorHex,
        }}
        dangerouslySetInnerHTML={{__html: model.component}}
      ></p>
    );
  }

  function renderPreview(model) {
    if (model.letter) return renderLetter(model);
    if (model.component) return renderComponent(model);
    return renderImage(model);
  }

  return (
    <div className={`card${selectedClass}`}>
      <div className="card-body">
        {selected && <div className="card-selected-label">&#10003;&nbsp;selected!</div>}

        <div className="card-preview-container" onClick={() => onClickActionBtn(productId, model)}>
          {renderPreview(model)}
        </div>

        <div className="card-title-container">
          <h4 className="card-title">{model.title}</h4>
          <h5 className="card-subtitle">{model.subtitle}</h5>
        </div>
      </div>
    </div>
  );
};

ProductCard.propTypes = {
  model: PropTypes.object.isRequired,
  productId: PropTypes.string.isRequired,
  onClickActionBtn: PropTypes.func.isRequired,
  banner: PropTypes.string,
};

export default ProductCard;
